import { useState, useRef, useEffect } from "react";
import axios from "axios";

export function useAdvanceStage({ API, code, me, players, state, navigate }) {
  const [advanceGate, setAdvanceGate] = useState(null);
  const [advanceModalOpen, setAdvanceModalOpen] = useState(false);
  const autoCommitRef = useRef(false);
  // Ref pour tracker le stage au moment où le gate a été créé
  const gateStageRef = useRef(null);

  const handleAdvanceStage = async () => {
    if (!state?.canAdvance) return;
    try {
      const res = await axios.post(`${API}/api/game/${code}/next-stage`, { playerId: me.id });
      if (res.data.finished) { navigate(`/scoreboard/${code}`); }
    } catch (err) { console.error("Erreur next-stage:", err.response?.data || err); }
  };

  const requestNextStageVote = async () => {
    if (!state?.canAdvance) return;
    try {
      const res = await axios.post(`${API}/api/game/${code}/request-next-stage`, { playerId: me.id });
      setAdvanceGate(res.data?.advanceGate || null);
      setAdvanceModalOpen(true);
    } catch (err) { console.error("Erreur request-next-stage:", err.response?.data || err); }
  };

  const setMyNextStageVote = async (vote) => {
    try {
      setAdvanceGate(prev => prev?.active ? { ...prev, votes: { ...(prev.votes || {}), [String(me.id)]: vote } } : prev);
      const res = await axios.patch(`${API}/api/game/${code}/next-stage-vote`, { playerId: me.id, vote });
      setAdvanceGate(res.data?.advanceGate || null);
    } catch (err) { console.error("Erreur next-stage-vote:", err.response?.data || err); }
  };

  // Ouvre la modale dès que le gate devient actif
  useEffect(() => {
    if (advanceGate?.active) {
      gateStageRef.current = advanceGate.stage;
      setAdvanceModalOpen(true);
    }
  }, [advanceGate?.active]);

  // Ferme la modale et nettoie quand le stage change (passage au stage suivant)
  useEffect(() => {
    if (!state?.stage) return;
    // Si le stage actuel est différent du stage du gate, le gate est obsolète
    if (gateStageRef.current !== null && Number(state.stage) !== Number(gateStageRef.current)) {
      setAdvanceModalOpen(false);
      setAdvanceGate(null);
      autoCommitRef.current = false;
      gateStageRef.current = null;
    }
  }, [state?.stage]);

  // Auto-commit quand tout le monde a voté yes
  useEffect(() => {
    const voteGateActive = !!advanceGate?.active && Number(advanceGate?.stage) === Number(state?.stage);
    const allYes = voteGateActive && players.length > 0 && players.every(
      p => (advanceGate?.votes?.[String(p.id)] || "pending") === "yes"
    );
    if (!voteGateActive) { autoCommitRef.current = false; return; }
    if (allYes && !autoCommitRef.current) {
      autoCommitRef.current = true;
      if (state?.canAdvance) handleAdvanceStage();
    }
  }, [advanceGate, players, state?.stage, state?.canAdvance]);

  return {
    advanceGate,
    setAdvanceGate,
    advanceModalOpen,
    setAdvanceModalOpen,
    requestNextStageVote,
    setMyNextStageVote,
  };
}